/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathSin = createReactComponent("outline", "math-sin", "IconMathSin", [["path", { "d": "M4 15c.345 .6 1.258 1 2 1a2 2 0 1 0 0 -4a2 2 0 1 1 0 -4c.746 0 1.656 .394 2 1", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M16 16v-8l4 8v-8", "key": "svg-2" }]]);

export { IconMathSin as default };
//# sourceMappingURL=IconMathSin.mjs.map
